import React from 'react';

const TryAgainPill = () => {
  return (
    <>
      <div className="TryAgainPill d-flex">Try Again</div>
    </>
  );
};

export default TryAgainPill;
